<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
    style="margin-top: -0.8rem;"
    align-h="between"
  >
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>

          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item
                :to="isExternalUser() ? { name: 'portaldocumentos-externo' } : { name: telaInicial() }"
              >
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>

              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <b-col
      class="content-header-right text-md-right d-md-flex d-none"
      cols="auto"
    >
      <b-row align-h="end">
        <b-col cols="auto">
          <div style="display: flex; justify-content: flex-end;">
            <cadastro-proposta
              v-if="$route.meta.useButtonProposta && permitidoCriarProposta()"
              class="mr-50"
              :auto-open-modal="false"
            />
            <b-btn
              v-if="$route.meta.useButtonDashBoardComercial"
              v-b-tooltip.hover
              variant="none"
              style="padding:0.5rem; float:right; margin-right: 0.5rem;"
              class="btn-outline-primary btn-sm"
              :title="'Abrir dashboard'"
              @click="abrirDashboardComercial()"
            >
              <font-awesome-icon
                class="text-primary"
                :icon="['fas', 'chart-line']"
                style="font-size: 14px !important;"
              />
              <span style="color: #6e6b7b; margin-left: 0.4rem;">Dashboard</span>
            </b-btn>
            <b-btn
              v-if="$route.meta.useButtonGruposEmpresariais"
              v-b-tooltip.hover
              variant="none"
              style="padding:0.5rem; float:right; margin-right: 0.5rem;"
              class="btn-outline-primary btn-sm"
              :title="'Ir para Grupos Empresariais'"
              @click="irParaGruposEmpresariais()"
            >
              <font-awesome-icon
                class="text-primary"
                :icon="['fas', 'layer-group']"
                style="font-size: 14px !important;"
              />
              <span style="color: #6e6b7b; margin-left: 0.4rem;">Grupos Empresariais</span>
            </b-btn>

            <b-btn
              v-if="$route.meta.useButtonDashBoardCobranca"
              v-b-tooltip.hover
              variant="none"
              style="padding:0.5rem; float:right; margin-right: 0.5rem;"
              class="btn-outline-primary btn-sm"
              :title="'Abrir dashboard'"
              @click="abrirDashboardCobranca()"
            >
              <font-awesome-icon
                class="text-primary"
                :icon="['fas', 'chart-pie']"
                style="font-size: 14px !important;"
              />
              <span style="color: rgb(110, 107, 123); margin-left: 0.4rem;">Dashboard</span>
            </b-btn>

            <procedimentos
              v-if="!isExternalUser()"
              :route="$route"
            />
          </div>
        </b-col>

        <b-col
          v-if="isExternalUser()"
          :cols="isExternalUser() ? '12' : '10'"
        >
          <responsaveis />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
@media screen and (max-width: 770px) {
  .content-header-right {
    display: block !important;
  }
}
</style>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BBtn,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { isExternalAccess, getUserData } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BBtn,
    FontAwesomeIcon,
    procedimentos: () => import('@/shared/components/procedimentos/Procedimentos.vue'),
    responsaveis: () => import('@/shared/components/visualizar-responsaveis/VisualizarResponsaveis.vue'),
    cadastroProposta: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
  },
  methods: {
    irParaGruposEmpresariais() {
      this.$router.push({ name: 'gruposempresariais' })
    },

    isExternalUser() {
      return isExternalAccess()
    },
    telaInicial() {
      if (localStorage.moduloSelecionado === 'Comercial') {
        return 'dashboard-comercial'
      }
      return 'dashboard-cobranca'
    },
    permitidoCriarProposta() {
      const userData = getUserData()
      if (userData.admin) {
        return true
      }
      const proposta = userData.ability.some(fin => (
        fin.subject === 'proposta' && fin.actions.some(fi => fi === 'create')
      ))
      return proposta
    },
    abrirDashboardCobranca() {
      const userData = getUserData()
      const pode = userData.admin || userData.ability.some(fin => (
        fin.subject === 'dashboardcobranca' && fin.actions.some(fi => fi === 'read')
      ))
      if (pode) {
        abrirEmNovaGuia('dashboard-cobranca')
      } else {
        this.$erro('Você não tem permissão para acessar esse recurso. Contate o administrador.')
      }
    },
    abrirDashboardComercial() {
      const userData = getUserData()
      const pode = userData.admin || userData.ability.some(fin => (
        fin.subject === 'dashboardcomercial' && fin.actions.some(fi => fi === 'read')
      ))
      if (pode) {
        abrirEmNovaGuia('dashboard-comercial')
      } else {
        this.$erro('Você não tem permissão para acessar esse recurso. Contate o administrador.')
      }
    },
  },
}
</script>
